import Cookies from 'js-cookie'
import UaParser from 'ua-parser-js'
import _ from 'underscore'
import { version } from '../../../package.json'

let util = {
  cookies: {},
  query: {}
}
/**
 * @description 存储 cookie 值
 * @param {String} name cookie name
 * @param {String} value cookie value
 * @param {Object} setting cookie setting
 */
util.cookies.set = function (name = 'default', value = '', setting = {}) {
  let cookieSetting = {
    expires: 1
  }
  Object.assign(cookieSetting, setting)
  Cookies.set(`d2admin-${version}-${name}`, value, cookieSetting)
}

/**
 * @description 拿到 cookie 值
 * @param {String} name cookie name
 */
util.cookies.get = function (name = 'default') {
  return Cookies.get(`d2admin-${version}-${name}`)
}

/**
 * @description 拿到 cookie 全部的值
 */
util.cookies.getAll = function () {
  return Cookies.get()
}

/**
 * @description 删除 cookie
 * @param {String} name cookie name
 */
util.cookies.remove = function (name = 'default') {
  return Cookies.remove(`d2admin-${version}-${name}`)
}

const encodeReserveRE = /[!'()*]/g
const encodeReserveReplacer = c => '%' + c.charCodeAt(0).toString(16)
const commaRE = /%2C/g

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
const encode = str => encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ',')
const decode = decodeURIComponent

/**
 * @description 转换查询字符串为对象
 * @param {String} query 查询字符串
 */
util.query.parse = function (query) {
  // console.log("--parseQuery--")
  const res = {}
  query = query.trim().replace(/^(\?|#|&)/, '')
  if (!query) {
    return res
  }
  // console.log("query",JSON.stringify(query))
  query.split('&').forEach(param => {
    let s = param.replace(/\+/g, ' ')
    let parts = []
    parts.push(s.substring(0, s.indexOf(`=`)))
    parts.push(s.substring(s.indexOf(`=`) + 1))
    // console.log("parts",JSON.stringify(parts))
    let key = decode(parts[0])
    let val = parts.length > 1
      ? decode(parts[1])
      : null
    // console.log("key",key,"val",val);
    if (res[key] === undefined) {
      let n = Number(val)
      if (val.indexOf('[{') === 0) {
        val = JSON.parse(val)
      } else if (val === 'true') {
        val = true
      } else if (val === 'false') {
        val = false
      } else if (val.length < 11 && !isNaN(n)) {
        val = n
      }
      res[key] = val
    } else if (Array.isArray(res[key])) {
      res[key].push(val)
    } else {
      res[key] = [res[key], val]
    }
  })
  // console.log("res",res)
  return res
}
/**
 * @description 转换对象为查询字符串
 * @param {String} query 对象
 */
util.query.stringify = function (obj) {
  const res = obj ? Object.keys(obj).map(key => {
    const val = obj[key]

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      if (_.isObject(val[0])) {
        return encode(key) + '=' + encode(JSON.stringify(val))
      } else {
        const result = []
        val.forEach(val2 => {
          if (val2 === undefined) {
            return
          }
          if (val2 === null) {
            result.push(encode(key))
          } else {
            result.push(encode(key) + '=' + encode(val2))
          }
        })
        return result.join('&')
      }
    }
    return encode(key) + '=' + encode(val)
  }).filter(x => x.length > 0).join('&') : null
  // console.log("res",res)
  return res ? `?${res}` : ''
}

/**
* @description 更新标题
* @param {String} title 标题
*/
util.title = function (titleText) {
  window.document.title = `${titleText}`
}

/**
 * @description 获取所有的 UA 信息
 */
util.ua = function () {
  return new UaParser().getResult()
}

/**
 * @description 判断是否在其内
 * @param {*} ele element
 * @param {Array} targetArr array
 */
util.isOneOf = function (ele, targetArr) {
  if (targetArr.indexOf(ele) >= 0) {
    return true
  } else {
    return false
  }
}

/**
 * @description 打印一个 “胶囊” 样式的信息
 * @param {String} title title text
 * @param {String} info info text
 */
util.logCapsule = function (title, info) {
  console.log(
    `%c ${title} %c ${info} %c`,
    'background:#29384b; padding: 1px; border-radius: 3px 0 0 3px; color: #fff',
    'background:#3488ff; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff',
    'background:transparent'
  )
}

/**
 * @description 显示版本信息
 */
util.showInfo = function showInfo () {
  util.logCapsule('D2Admin Start Kit', `v${version}`)
  console.log('Github https://github.com/d2-projects/d2-admin')
  console.log('Doc    http://d2admin.fairyever.com/zh/')
}

export default util
